<app-side-menu>
  <div class="stock-alerts-container">
    <!-- Filtros -->
    <div class="filters-section">
      <div class="filters-row">
        <div class="filter-group">
          <label for="stockFilter" class="form-label">Filtrar por Estoque:</label>
          <select 
            id="stockFilter" 
            class="form-select" 
            [(ngModel)]="filters.stockId"
            (change)="applyFilters()">
            <option value="">Todos os estoques</option>
            <option *ngFor="let stock of stocks" [value]="stock.id">
              {{ stock.name }} ({{ stock.code }})
            </option>
          </select>
        </div>

        <div class="filter-group">
          <label for="warehouseFilter" class="form-label">Filtrar por Almoxarifado:</label>
          <select 
            id="warehouseFilter" 
            class="form-select" 
            [(ngModel)]="filters.warehouseId"
            (change)="applyFilters()">
            <option value="">Todos os almoxarifados</option>
            <option *ngFor="let warehouse of warehouses" [value]="warehouse.id">
              {{ warehouse.name }} ({{ warehouse.code }})
            </option>
          </select>
        </div>

        <div class="filter-group">
          <label for="alertTypeFilter" class="form-label">Filtrar por Tipo:</label>
          <select 
            id="alertTypeFilter" 
            class="form-select" 
            [(ngModel)]="filters.alertType"
            (change)="applyFilters()">
            <option value="">Todos os tipos</option>
            <option *ngFor="let type of alertTypes" [value]="type.value">
              {{ type.label }}
            </option>
          </select>
        </div>

        <div class="filter-group">
          <label for="statusFilter" class="form-label">Filtrar por Status:</label>
          <select 
            id="statusFilter" 
            class="form-select" 
            [(ngModel)]="filters.status"
            (change)="applyFilters()">
            <option value="">Todos</option>
            <option *ngFor="let status of statuses" [value]="status.name">{{ status.name }}</option>
          </select>
        </div>

        <div class="filter-actions">
          <button 
            type="button" 
            class="btn btn-outline-secondary"
            (click)="clearFilters()">
            <i class="fas fa-times me-2"></i>
            Limpar Filtros
          </button>
        </div>
      </div>
    </div>

    <!-- Estatísticas de Alertas -->
    <div class="alerts-summary" *ngIf="!isLoading && stockAlerts.length > 0">
      <div class="summary-cards">
        <div class="summary-card">
          <div class="summary-icon">
            <i class="fas fa-exclamation-triangle text-warning"></i>
          </div>
          <div class="summary-info">
            <div class="summary-number">{{ getUrgentCount() }}</div>
            <div class="summary-label">Urgentes</div>
          </div>
        </div>
        <div class="summary-card">
          <div class="summary-icon">
            <i class="fas fa-clock text-info"></i>
          </div>
          <div class="summary-info">
            <div class="summary-number">{{ getUnresolvedCount() }}</div>
            <div class="summary-label">Não Resolvidos</div>
          </div>
        </div>
        <div class="summary-card">
          <div class="summary-icon">
            <i class="fas fa-check-circle text-success"></i>
          </div>
          <div class="summary-info">
            <div class="summary-number">{{ getResolvedCount() }}</div>
            <div class="summary-label">Resolvidos</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Tabela de Alertas -->
    <div *ngIf="!isLoading && !error && filteredData.length > 0">
      <app-table
        [title]="tableTitle"
        [columns]="columns"
        [data]="filteredData"
        [loading]="isLoading"
        [showSearch]="showSearch"
        [searchPlaceholder]="searchPlaceholder"
        [clickable]="clickable"
        [actions]="actions"
        [totalItemsFromBackend]="totalItems"
        [itemsPerPage]="pageSize"
        (pageChange)="onPageChange($any($event))"
        (pageSizeChange)="onPageSizeChange($any($event))"
        (actionClick)="onActionClick($any($event))">
        <app-button
          table-header-action
          text="Atualizar Alertas"
          [color]="'var(--primary-light)'"
          [height]="'42px'"
          className="refresh-alerts-btn"
          (buttonClick)="refreshAlerts()">
        </app-button>
      </app-table>
    </div>

    <!-- Estado Vazio Simples -->
    <div *ngIf="!isLoading && !error && filteredData.length === 0" class="empty-state-simple">
      <div class="empty-message">
        <i class="fas fa-bell-slash"></i>
        <p>Nenhum alerta encontrado</p>
      </div>
    </div>

<!-- Error Message -->
    <div *ngIf="error" class="alert alert-danger" role="alert">
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <i class="fas fa-exclamation-triangle me-2"></i>
          {{ error }}
        </div>
        <button
          type="button"
          class="btn btn-outline-danger btn-sm"
          (click)="retryLoad()">
          <i class="fas fa-redo me-1"></i>
          Tentar Novamente
        </button>
      </div>
    </div>

  </div>
</app-side-menu>
